
    var riot = require('riot')
    //src: starling/src/tags/app-footer.html
riot.tag2('app-footer',
  '<div if="{!this.parent.isViewOnly() && this.showMessage()}" class="instruction-container"> <div if="{!this.parent.isViewOnly() && this.showMessage()}" class="instruction-container_bar" ref="instruction"> <svg class="app-footer_icon"> <use xlink:href="#double-click-icon"></use> </svg> Double-click anywhere to create a card, or get started with a <a href="#" onclick="{showTemplatesModal}">template</a>... </div> </div> <div class="print-footer"> <div class="print-watermark">created with<br><span class="logo"></span></div> </div>',
  'app-footer { display: none; }',
  '', function(opts) {
"use strict";

var _this = this;

this.canvas = this.opts.canvas;
this.canvas.appFooterTag = this;

this.showTemplatesModal = function (e) {
  e.preventDefault();
  _this.canvas.templatesModal.show();
};

this.updateStyle = function () {
  _this.update();
};

this.showMessage = function () {
  var store = _this.canvas.store;
  return store.getNodesSize() == 0 && store.getRegions().length == 0;
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('app-footer')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/app-footer.html
// module id = 625
// module chunks = 0